// import React from "react";
// import isprl from "../isprl.png";
// import "./isolationAllTemplate.css";

// const formatDate = (dateString) => {
//   if (!dateString) return "";

//   const date = new Date(dateString);
//   if (Number.isNaN(date.getTime())) return "";

//   const day = String(date.getUTCDate()).padStart(2, "0");
//   const month = String(date.getUTCMonth() + 1).padStart(2, "0");
//   const year = date.getUTCFullYear();
//   return `${day}/${month}/${year}`;
// };

// const formatTime = (dateString) => {
//   if (!dateString) return "";

//   const date = new Date(dateString);
//   if (Number.isNaN(date.getTime())) return "";

//   return date.toLocaleTimeString("en-US", {
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//     timeZone: "UTC",
//   });
// };

// const hasValue = (value) =>
//   value !== undefined && value !== null && `${value}`.trim() !== "";

// const fillValue = (value) => (hasValue(value) ? value : "\u00A0");

// const isChecked = (value) => value === true || value === 1 || value === "1";

// const actionChecked = (actions, value) =>
//   Array.isArray(actions) && actions.includes(value);

// const CheckItem = ({ checked, children }) => (
//   <span className="iso-check-item">
//     <span className={`iso-check-box${checked ? " checked" : ""}`}>
//       {checked ? <span className="iso-check-tick">✓</span> : null}
//     </span>
//     <span>{children}</span>
//   </span>
// );

// const SignatureCell = ({ label, value, className = "" }) => (
//   <div className={`iso-sign-cell ${className}`.trim()}>
//     <div className="iso-sign-label">{label}</div>
//     <div className="iso-sign-value">{fillValue(value)}</div>
//   </div>
// );

// const IsolationPermitTemplate = ({ permitDetails }) => {
//   const {
//     permit = {},
//     isolation_details: isolationDetails = {},
//     energisation_details: energisationDetails = {},
//   } = permitDetails || {};

//   const isolationActions = isolationDetails?.isolation_actions_taken || [];

//   const energisationDepartment =
//     energisationDetails?.department_section_area ||
//     energisationDetails?.energisation_department ||
//     "";
//   const energisationEquipmentNumber =
//     energisationDetails?.equipment_number ||
//     energisationDetails?.energisation_equipment_number ||
//     "";
//   const energisationEquipmentName =
//     energisationDetails?.equipment_circuit_name ||
//     energisationDetails?.energisation_equipment_circuit_name ||
//     "";
//   const energisationRequesterName =
//     energisationDetails?.requested_by_name ||
//     energisationDetails?.energisation_requested_by_name ||
//     "";
//   const energisationRequesterDesignation =
//     energisationDetails?.requested_by_designation ||
//     energisationDetails?.energisation_requested_by_designation ||
//     "";

//   return (
//     <div id="section1" className="isolation-work-template">
//       <div className="iso-page-shell">
//         <header className="iso-page-header">
//           <div className="iso-page-logo">
//             <img src={isprl} alt="ISPRL Logo" />
//           </div>

//           <div className="iso-page-heading">
//             <div className="iso-line-hi">
//               इंडियन स्ट्रेटेजिक पेट्रोलियम रिजर्व्स लिमिटेड
//             </div>
//             <div className="iso-line-en">
//               INDIAN STRATEGIC PETROLEUM RESERVES LIMITED
//             </div>
//             <div className="iso-line-hi">
//               स्ट्रेटेजिक क्रूड स्टोरेज फैसिलिटी, पादुर
//             </div>
//             <div className="iso-line-en">STRATEGIC CRUDE STORAGE FACILITY, PADUR</div>
//             <div className="iso-line-hi iso-title-hi">
//               विद्युत अलगाव / ऊर्जीकरण अनुमति
//             </div>
//             <div className="iso-line-en iso-title-en">
//               Electrical Isolation / Energisation Permit
//             </div>
//             <div className="iso-line-ref">
//               (ओआईएसडी एसटीडी-105, अनुबंध-III के अनुसार) / (As per OISD STD-105,
//               Annexure - III)
//             </div>
//           </div>

//           <div className="iso-page-meta">
//             <div className="iso-meta-row">
//               <span className="iso-meta-label">क्रम सं. / Sl. No.</span>
//               <span className="iso-meta-fill">{fillValue(permit?.serial_number)}</span>
//             </div>
//             <div className="iso-meta-row">
//               <span className="iso-meta-label">दिनांक / Date</span>
//               <span className="iso-meta-fill">{fillValue(formatDate(permit?.issued_date))}</span>
//             </div>
//             <div className="iso-meta-row">
//               <span className="iso-meta-label">समय / Time</span>
//               <span className="iso-meta-fill">{fillValue(formatTime(permit?.issued_date))}</span>
//             </div>
//           </div>
//         </header>

//         <div className="iso-page-body">
//           <section className="iso-section">
//             <div className="iso-section-heading">
//               अनुभाग-'अ': अलगाव की अनुमति / Section-A: Isolation Permit
//             </div>

//             <div className="iso-row iso-row-inline">
//               <span className="iso-label">
//                 अलगाव के लिए अनुरोध / Request for Isolation:
//               </span>
//               <span className="iso-label iso-inline-gap">दिनांक / Date</span>
//               <span className="iso-fill iso-fill-sm">
//                 {fillValue(formatDate(isolationDetails?.request_date))}
//               </span>
//               <span className="iso-label iso-inline-gap">समय / Time</span>
//               <span className="iso-fill iso-fill-sm">
//                 {fillValue(formatTime(isolationDetails?.request_date))}
//               </span>
//             </div>

//             <div className="iso-row">
//               <span className="iso-label">
//                 विभाग / अनुभाग / क्षेत्र परमिट जारी करने वाला / Department / Section /
//                 Area issuing the permit
//               </span>
//               <span className="iso-fill">
//                 {fillValue(isolationDetails?.department_section_area || permit?.section)}
//               </span>
//             </div>

//             <div className="iso-row">
//               <span className="iso-label">
//                 उपकरण क्रमांक जिसे अलग किया जाना है / Equipment number to be isolated
//               </span>
//               <span className="iso-fill">
//                 {fillValue(isolationDetails?.equipment_number)}
//               </span>
//             </div>

//             <div className="iso-row">
//               <span className="iso-label">
//                 उपकरण / सर्किट का नाम जिसे अलग किया जाना है / Name of equipment /
//                 circuit to be isolated
//               </span>
//               <span className="iso-fill">
//                 {fillValue(isolationDetails?.equipment_circuit_name)}
//               </span>
//             </div>

//             <div className="iso-row iso-row-stack">
//               <div className="iso-text-block">
//                 उपर्युक्त उपकरण / सर्किट को डी-एनर्जाइज कर सभी लाइव कंडक्टरों से अलग
//                 किया जाएगा।
//                 <br />
//                 The above mentioned equipment / circuit shall be de-energized and
//                 isolated from all live conductors to carry out the maintenance work
//                 by
//               </div>
//               <div className="iso-row iso-row-nested">
//                 <span className="iso-fill">
//                   {fillValue(isolationDetails?.maintenance_work_by)}
//                 </span>
//               </div>
//             </div>

//             <div className="iso-row">
//               <span className="iso-label">
//                 अनुभाग / परिचालन आवश्यकता के लिए / section / for operational
//                 requirement
//               </span>
//               <span className="iso-fill">{fillValue("")}</span>
//             </div>

//             <div className="iso-option-row">
//               <span className="iso-label">उपयोग / Using (tick relevant):</span>
//               <CheckItem checked={actionChecked(isolationActions, "switches")}>
//                 स्विच / Switches
//               </CheckItem>
//               <CheckItem checked={actionChecked(isolationActions, "isolators")}>
//                 आइसोलेटर / Isolators
//               </CheckItem>
//               <CheckItem checked={actionChecked(isolationActions, "links")}>
//                 लिंक / Links
//               </CheckItem>
//               <CheckItem checked={actionChecked(isolationActions, "fuses")}>
//                 फ्यूज / Fuses
//               </CheckItem>
//             </div>

//             <div className="iso-sign-row">
//               <SignatureCell
//                 label="द्वारा अनुरोध किया गया / Requested by"
//                 value={isolationDetails?.requested_by_name}
//                 className="iso-sign-wide"
//               />
//               <SignatureCell
//                 label="पद / Designation"
//                 value={isolationDetails?.requested_by_designation}
//               />
//               <SignatureCell label="हस्ताक्षर / Signature" value="" />
//             </div>

//             <div className="iso-section-subheading">
//               अलगाव का प्रमाण पत्र / Certificate of Isolation
//             </div>

//             <div className="iso-row iso-row-inline">
//               <span className="iso-label">दिनांक / Date</span>
//               <span className="iso-fill iso-fill-sm">
//                 {fillValue(formatDate(isolationDetails?.cert_date))}
//               </span>
//               <span className="iso-label iso-inline-gap">समय / Time</span>
//               <span className="iso-fill iso-fill-sm">
//                 {fillValue(formatTime(isolationDetails?.cert_time))}
//               </span>
//             </div>

//             <div className="iso-row iso-row-stack">
//               <div className="iso-inline-line">
//                 <span className="iso-label">
//                   प्रमाणित किया जाता है कि उपकरण / सर्किट क्र. / Certified that
//                   Equipment / Circuit no.
//                 </span>
//                 <span className="iso-fill iso-fill-sm">
//                   {fillValue(isolationDetails?.certified_equipment_circuit_no)}
//                 </span>
//                 <span className="iso-label iso-inline-gap">का / of</span>
//                 <span className="iso-fill iso-fill-md">
//                   {fillValue(isolationDetails?.ka_of)}
//                 </span>
//               </div>

//               <div className="iso-text-block">
//                 संयंत्र को स्विच / आइसोलेटर / लिंक / फ्यूज द्वारा विद्युत रूप से अलग
//                 किया गया है और सप्लाई पैनल पर खतरे का टैग लगाया गया है।
//                 <br />
//                 Plant has been electrically isolated by switches / isolators /
//                 links / fuses and the danger tag is put on the supply panel.
//               </div>

//               <div className="iso-option-row iso-option-row-compact">
//                 <CheckItem checked={actionChecked(isolationActions, "switches")}>
//                   स्विच / Switches
//                 </CheckItem>
//                 <CheckItem checked={actionChecked(isolationActions, "isolators")}>
//                   आइसोलेटर / Isolators
//                 </CheckItem>
//                 <CheckItem checked={actionChecked(isolationActions, "links")}>
//                   लिंक / Links
//                 </CheckItem>
//                 <CheckItem checked={actionChecked(isolationActions, "fuses")}>
//                   फ्यूज / Fuses
//                 </CheckItem>
//                 <CheckItem checked={isChecked(isolationDetails?.danger_tag_put)}>
//                   खतरे का टैग लगाया / Danger Tag Put
//                 </CheckItem>
//               </div>

//               <div className="iso-row iso-row-nested">
//                 <span className="iso-label">
//                   विद्युत अलगाव के संबंध में कार्यवाही इलेक्ट्रिकल शिफ्ट लॉगबुक में
//                   दर्ज की गई है / Actions in respect of electrical isolation have
//                   been recorded in the electrical shift logbook
//                 </span>
//               </div>

//               <div className="iso-inline-line iso-inline-line-end">
//                 <span className="iso-label">
//                   लॉक आउट टैग क्रमांक / Lock Out Tag No.
//                 </span>
//                 <span className="iso-fill iso-fill-sm">
//                   {fillValue(isolationDetails?.lockout_tag_no)}
//                 </span>
//               </div>
//             </div>

//             <div className="iso-sign-row">
//               <SignatureCell
//                 label="अधिकृत व्यक्ति का नाम / Name of Authorized Person"
//                 value={isolationDetails?.authorized_person_name}
//                 className="iso-sign-wide"
//               />
//               <SignatureCell
//                 label="पद / Designation"
//                 value={isolationDetails?.authorized_person_designation}
//               />
//               <SignatureCell label="हस्ताक्षर / Signature" value="" />
//             </div>
//           </section>

//           <section className="iso-section iso-section-b">
//             <div className="iso-section-heading">
//               अनुभाग-'ब': ऊर्जा की अनुमति / Section-B: Energisation Permit
//             </div>

//             <div className="iso-row iso-row-inline">
//               <span className="iso-label">
//                 ऊर्जा के लिए अनुरोध / Request for Energisation:
//               </span>
//               <span className="iso-label iso-inline-gap">दिनांक / Date</span>
//               <span className="iso-fill iso-fill-sm">
//                 {fillValue(formatDate(energisationDetails?.energisation_request_date))}
//               </span>
//               <span className="iso-label iso-inline-gap">समय / Time</span>
//               <span className="iso-fill iso-fill-sm">
//                 {fillValue(formatTime(energisationDetails?.energisation_request_date))}
//               </span>
//             </div>

//             <div className="iso-row">
//               <span className="iso-label">
//                 विभाग / अनुभाग / क्षेत्र परमिट जारी करने वाला / Department / Section /
//                 Area issuing the permit
//               </span>
//               <span className="iso-fill">{fillValue(energisationDepartment)}</span>
//             </div>

//             <div className="iso-row">
//               <span className="iso-label">
//                 उपकरण क्रमांक जिसे ऊर्जीकृत किया जाना है / Equipment number to be
//                 energized
//               </span>
//               <span className="iso-fill">
//                 {fillValue(
//                   energisationEquipmentName
//                     ? `${energisationEquipmentNumber} ${energisationEquipmentName}`.trim()
//                     : energisationEquipmentNumber,
//                 )}
//               </span>
//             </div>

//             <div className="iso-row iso-row-stack">
//               <div className="iso-text-block">
//                 उपर्युक्त उपकरण / सर्किट पर कार्य पूरा हो गया है और सभी लागू परमिट
//                 बंद हो गए हैं।
//                 <br />
//                 Work on the above mentioned equipment / circuit has been completed
//                 and all the applicable permits closed.
//                 <br />
//                 This equipment / circuit may be energized.
//               </div>
//             </div>

//             <div className="iso-sign-row">
//               <SignatureCell
//                 label="द्वारा अनुरोध किया गया / Requested by"
//                 value={energisationRequesterName}
//                 className="iso-sign-wide"
//               />
//               <SignatureCell
//                 label="पद / Designation"
//                 value={energisationRequesterDesignation}
//               />
//               <SignatureCell label="हस्ताक्षर / Signature" value="" />
//             </div>

//             <div className="iso-section-subheading">
//               ऊर्जा प्रदान करने का प्रमाण पत्र / Certificate of Energisation
//             </div>

//             <div className="iso-row iso-row-inline">
//               <span className="iso-label">दिनांक / Date</span>
//               <span className="iso-fill iso-fill-sm">
//                 {fillValue(formatDate(energisationDetails?.cert_date))}
//               </span>
//               <span className="iso-label iso-inline-gap">समय / Time</span>
//               <span className="iso-fill iso-fill-sm">
//                 {fillValue(formatTime(energisationDetails?.cert_time))}
//               </span>
//             </div>

//             <div className="iso-row iso-row-stack iso-grow">
//               <div className="iso-inline-line">
//                 <span className="iso-label">
//                   प्रमाणित किया जाता है कि उपकरण / सर्किट क्र. / Certified that
//                   Equipment / Circuit no.
//                 </span>
//                 <span className="iso-fill iso-fill-sm">
//                   {fillValue(energisationDetails?.certified_equipment_circuit_no)}
//                 </span>
//                 <span className="iso-label iso-inline-gap">का / of</span>
//                 <span className="iso-fill iso-fill-md">
//                   {fillValue(energisationDetails?.ka_of)}
//                 </span>
//               </div>

//               <div className="iso-text-block">
//                 संयंत्र को विद्युत रूप से ऊर्जीकृत किया गया है और सप्लाई पैनल से
//                 खतरे का टैग हटा दिया गया है।
//                 <br />
//                 Plant has been electrically energized and the danger tag removed
//                 from the supply panel. This is also recorded in the electrical
//                 shift logbook.
//               </div>

//               <div className="iso-section-b-footer">
//                 <div className="iso-option-row iso-option-row-compact">
//                   <CheckItem checked={isChecked(energisationDetails?.electrically_energized)}>
//                   विद्युत ऊर्जीकृत / Electrically Energized
//                 </CheckItem>
//                   <CheckItem checked={isChecked(energisationDetails?.danger_tag_removed)}>
//                   खतरे का टैग हटाया / Danger Tag Removed
//                 </CheckItem>
//                   <CheckItem
//                     checked={isChecked(
//                       energisationDetails?.work_completed_permits_closed,
//                     )}
//                   >
//                   कार्य पूर्ण एवं परमिट बंद / Work Completed &amp; Permits Closed
//                   </CheckItem>
//                 </div>

//                 <div className="iso-sign-row iso-sign-row-end">
//                 <SignatureCell
//                   label="अधिकृत व्यक्ति का नाम / Name of Authorized Person"
//                   value={energisationDetails?.authorized_person_name}
//                   className="iso-sign-wide"
//                 />
//                 <SignatureCell
//                   label="पद / Designation"
//                   value={energisationDetails?.authorized_person_designation}
//                 />
//                 <SignatureCell label="हस्ताक्षर / Signature" value="" />
//                 </div>
//               </div>
//             </div>
//           </section>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default IsolationPermitTemplate;


import React from "react";
import isprl from "../isprl.png";
import "./isolationAllTemplate.css";

const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "";
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();
  return `${day}/${month}/${year}`;
};

const formatTime = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "UTC",
  });
};

const hasValue = (value) =>
  value !== undefined && value !== null && `${value}`.trim() !== "";

const fillValue = (value) => (hasValue(value) ? value : "\u00A0");

const isChecked = (value) => value === true || value === 1 || value === "1";

const actionChecked = (actions, value) =>
  Array.isArray(actions) && actions.includes(value);

const CheckItem = ({ checked, children }) => (
  <span className="iso-check-item">
    <span className={`iso-check-box${checked ? " checked" : ""}`}>
      {checked ? <span className="iso-check-tick">✓</span> : null}
    </span>
    <span>{children}</span>
  </span>
);

const SignatureCell = ({ label, value, className = "" }) => (
  <div className={`iso-sign-cell ${className}`.trim()}>
    <div className="iso-sign-label">{label}</div>
    <div className="iso-sign-value">{fillValue(value)}</div>
  </div>
);

const IsolationPermitTemplate = ({ permitDetails }) => {
  const {
    permit = {},
    isolation_details: isolationDetails = {},
    energisation_details: energisationDetails = {},
  } = permitDetails || {};

  const isolationActions = isolationDetails?.isolation_actions_taken || [];

  const energisationDepartment =
    energisationDetails?.department_section_area ||
    energisationDetails?.energisation_department ||
    "";
  const energisationEquipmentNumber =
    energisationDetails?.equipment_number ||
    energisationDetails?.energisation_equipment_number ||
    "";
  const energisationEquipmentName =
    energisationDetails?.equipment_circuit_name ||
    energisationDetails?.energisation_equipment_circuit_name ||
    "";
  const energisationRequesterName =
    energisationDetails?.requested_by_name ||
    energisationDetails?.energisation_requested_by_name ||
    "";
  const energisationRequesterDesignation =
    energisationDetails?.requested_by_designation ||
    energisationDetails?.energisation_requested_by_designation ||
    "";

  return (
    <div id="section1" className="isolation-work-template">
      <div className="iso-page-shell">

        {/* ══════════════ HEADER ══════════════ */}
        <header className="iso-page-header">
          <div className="iso-page-logo">
            <img src={isprl} alt="ISPRL Logo" />
          </div>

          <div className="iso-page-heading">
            <div className="iso-line-hi">इंडियन स्ट्रेटेजिक पेट्रोलियम रिजर्व्स लिमिटेड</div>
            <div className="iso-line-en">INDIAN STRATEGIC PETROLEUM RESERVES LIMITED</div>
            <div className="iso-line-hi">स्ट्रेटेजिक क्रूड स्टोरेज फैसिलिटी, पादुर</div>
            <div className="iso-line-en">STRATEGIC CRUDE STORAGE FACILITY, PADUR</div>
            <div className="iso-line-title-hi">विद्युत अलगाव / ऊर्जीकरण अनुमति</div>
            <div className="iso-line-title-en">Electrical Isolation / Energisation Permit</div>
            <div className="iso-line-ref">
              (ओआईएसडी एसटीडी-105, अनुबंध-III के अनुसार) / (As per OISD STD-105, Annexure - III)
            </div>
          </div>

          <div className="iso-page-meta">
            <div className="iso-meta-row">
              <span className="iso-meta-label">क्रम सं. / Sl. No.</span>
              <span className="iso-meta-fill">{fillValue(permit?.serial_number)}</span>
            </div>
            <div className="iso-meta-row">
              <span className="iso-meta-label">दिनांक / Date</span>
              <span className="iso-meta-fill">{fillValue(formatDate(permit?.issued_date))}</span>
            </div>
            <div className="iso-meta-row">
              <span className="iso-meta-label">समय / Time</span>
              <span className="iso-meta-fill">{fillValue(formatTime(permit?.issued_date))}</span>
            </div>
          </div>
        </header>

        {/* ══════════════ BODY ══════════════ */}
        <div className="iso-page-body">

          {/* ════ SECTION A : Isolation Permit ════ */}
          <section className="iso-section">
            <div className="iso-section-heading">
              अनुभाग-'अ': अलगाव की अनुमति / Section-A: Isolation Permit
            </div>

            {/* Row 1 – Request date/time */}
            <div className="iso-row">
              <span className="iso-label-bold">अलगाव के लिए अनुरोध / Request for Isolation:</span>
              <span className="iso-label-bold iso-gap">दिनांक / Date</span>
              <span className="iso-fill iso-fill-sm">{fillValue(formatDate(isolationDetails?.request_date))}</span>
              <span className="iso-label-bold iso-gap">समय / Time</span>
              <span className="iso-fill iso-fill-sm">{fillValue(formatTime(isolationDetails?.request_date))}</span>
            </div>

            {/* Row 2 – Department */}
            <div className="iso-row">
              <span className="iso-label-bold iso-label-wrap">
                विभाग / अनुभाग / क्षेत्र परमिट जारी करने वाला /<br />
                Department / Section / Area issuing the permit
              </span>
              <span className="iso-fill">{fillValue(isolationDetails?.department_section_area || permit?.section)}</span>
            </div>

            {/* Row 3 – Equipment number */}
            <div className="iso-row">
              <span className="iso-label-bold iso-label-wrap">
                उपकरण क्रमांक जिसे अलग किया जाना है /<br />
                Equipment number to be isolated
              </span>
              <span className="iso-fill">{fillValue(isolationDetails?.equipment_number)}</span>
            </div>

            {/* Row 4 – Equipment name */}
            <div className="iso-row">
              <span className="iso-label-bold iso-label-wrap">
                उपकरण / सर्किट का नाम जिसे अलग किया जाना है /<br />
                Name of equipment / circuit to be isolated
              </span>
              <span className="iso-fill">{fillValue(isolationDetails?.equipment_circuit_name)}</span>
            </div>

            {/* Row 5 – De-energize statement */}
            <div className="iso-row iso-row-wrap">
              <span className="iso-label-bold">
                उपर्युक्त उपकरण / सर्किट को डी-एनर्जाइज कर सभी लाइव कंडक्टरों से अलग किया जाएगा।<br />
                The above mentioned equipment / circuit shall be de-energized and isolated from all live conductors to carry out the maintenance work by
              </span>
              <span className="iso-fill iso-fill-by">{fillValue(isolationDetails?.maintenance_work_by)}</span>
            </div>

            {/* Row 6 – Section / operational */}
            <div className="iso-row">
              <span className="iso-label-bold iso-label-wrap">
                अनुभाग / परिचालन आवश्यकता के लिए /<br />
                section / for operational requirement
              </span>
              <span className="iso-fill">&nbsp;</span>
            </div>

            {/* Row 7 – Using checkboxes */}
            <div className="iso-option-row">
              <span className="iso-label-bold">उपयोग / Using (tick relevant):</span>
              <CheckItem checked={actionChecked(isolationActions, "switches")}>स्विच / Switches</CheckItem>
              <CheckItem checked={actionChecked(isolationActions, "isolators")}>आइसोलेटर / Isolators</CheckItem>
              <CheckItem checked={actionChecked(isolationActions, "links")}>लिंक / Links</CheckItem>
              <CheckItem checked={actionChecked(isolationActions, "fuses")}>फ्यूज / Fuses</CheckItem>
            </div>

            {/* Signature row – Requested by */}
            <div className="iso-sign-row">
              <SignatureCell label="द्वारा अनुरोध किया गया / Requested by" value={isolationDetails?.requested_by_name} className="iso-sign-wide" />
              <SignatureCell label="पद / Designation" value={isolationDetails?.requested_by_designation} />
              <SignatureCell label="हस्ताक्षर / Signature" value="" />
            </div>

            {/* ── Certificate of Isolation ── */}
            <div className="iso-section-subheading">
              अलगाव का प्रमाण पत्र / Certificate of Isolation
            </div>

            {/* Cert date/time */}
            <div className="iso-row">
              <span className="iso-label-bold">दिनांक / Date</span>
              <span className="iso-fill iso-fill-sm">{fillValue(formatDate(isolationDetails?.cert_date))}</span>
              <span className="iso-label-bold iso-gap">समय / Time</span>
              <span className="iso-fill iso-fill-sm">{fillValue(formatTime(isolationDetails?.cert_time))}</span>
            </div>

            {/* Certified that Equipment Circuit no. */}
            <div className="iso-row iso-row-wrap">
              <span className="iso-label-bold">
                प्रमाणित किया जाता है कि उपकरण / सर्किट क्र. / Certified that Equipment / Circuit no.
              </span>
              <span className="iso-fill iso-fill-sm">{fillValue(isolationDetails?.certified_equipment_circuit_no)}</span>
              <span className="iso-label-bold iso-gap">का / of</span>
              <span className="iso-fill iso-fill-md">{fillValue(isolationDetails?.ka_of)}</span>
            </div>

            {/* Isolated text + checkboxes on same block */}
            <div className="iso-cert-block">
              <span className="iso-label-bold">
                संयंत्र को स्विच / आइसोलेटर / लिंक / फ्यूज (tick as applicable) द्वारा विद्युत रूप से अलग किया गया है और सप्लाई पैनल पर खतरे का टैग लगाया गया है।<br />
                Plant has been electrically isolated by switches / isolators / links / fuses and the danger tag is put on the supply panel.
              </span>
              <div className="iso-option-row iso-option-row-compact">
                <CheckItem checked={actionChecked(isolationActions, "switches")}>स्विच / Switches</CheckItem>
                <CheckItem checked={actionChecked(isolationActions, "isolators")}>आइसोलेटर / Isolators</CheckItem>
                <CheckItem checked={actionChecked(isolationActions, "links")}>लिंक / Links</CheckItem>
                <CheckItem checked={actionChecked(isolationActions, "fuses")}>फ्यूज / Fuses</CheckItem>
                <CheckItem checked={isChecked(isolationDetails?.danger_tag_put)}>खतरे का टैग लगाया / Danger Tag Put</CheckItem>
              </div>
            </div>

            {/* Logbook note */}
            <div className="iso-logbook-row">
              <span className="iso-label-bold">
                विद्युत अलगाव के संबंध में कार्यवाही इलेक्ट्रिकल शिफ्ट लॉगबुक में दर्ज की गई है / Actions in respect of electrical isolation have been recorded in the electrical shift logbook
              </span>
              <span className="iso-lockout-right">
                <span className="iso-label-bold">लॉक आउट टैग क्रमांक / Lock Out Tag No.</span>
                <span className="iso-fill iso-fill-sm">{fillValue(isolationDetails?.lockout_tag_no)}</span>
              </span>
            </div>

            {/* Signature row – Authorized Person */}
            <div className="iso-sign-row">
              <SignatureCell label="अधिकृत व्यक्ति का नाम / Name of Authorized Person" value={isolationDetails?.authorized_person_name} className="iso-sign-wide" />
              <SignatureCell label="पद / Designation" value={isolationDetails?.authorized_person_designation} />
              <SignatureCell label="हस्ताक्षर / Signature" value="" />
            </div>
          </section>

          {/* ════ SECTION B : Energisation Permit ════ */}
          <section className="iso-section iso-section-b">
            <div className="iso-section-heading">
              अनुभाग-'ब': ऊर्जा की अनुमति / Section-B: Energisation Permit
            </div>

            {/* Row 1 – Request date/time */}
            <div className="iso-row">
              <span className="iso-label-bold">ऊर्जा के लिए अनुरोध / Request for Energisation:</span>
              <span className="iso-label-bold iso-gap">दिनांक / Date</span>
              <span className="iso-fill iso-fill-sm">{fillValue(formatDate(energisationDetails?.energisation_request_date))}</span>
              <span className="iso-label-bold iso-gap">समय / Time</span>
              <span className="iso-fill iso-fill-sm">{fillValue(formatTime(energisationDetails?.energisation_request_date))}</span>
            </div>

            {/* Row 2 – Department */}
            <div className="iso-row">
              <span className="iso-label-bold iso-label-wrap">
                विभाग / अनुभाग / क्षेत्र परमिट जारी करने वाला /<br />
                Department / Section / Area issuing the permit
              </span>
              <span className="iso-fill">{fillValue(energisationDepartment)}</span>
            </div>

            {/* Row 3 – Equipment number */}
            <div className="iso-row">
              <span className="iso-label-bold iso-label-wrap">
                उपकरण क्रमांक जिसे ऊर्जीकृत किया जाना है /<br />
                Equipment number to be energized
              </span>
              <span className="iso-fill">
                {fillValue(
                  energisationEquipmentName
                    ? `${energisationEquipmentNumber} ${energisationEquipmentName}`.trim()
                    : energisationEquipmentNumber
                )}
              </span>
            </div>

            {/* Row 4 – Work completed statement */}
            <div className="iso-row iso-row-wrap">
              <span className="iso-label-bold">
                उपर्युक्त उपकरण / सर्किट पर कार्य पूरा हो गया है और सभी लागू परमिट बंद हो गए हैं।<br />
                Work on the above mentioned equipment / circuit has been completed and all the applicable permits closed.<br />
                This equipment / circuit may be energized.
              </span>
            </div>

            {/* Signature row – Requested by */}
            <div className="iso-sign-row">
              <SignatureCell label="द्वारा अनुरोध किया गया / Requested by" value={energisationRequesterName} className="iso-sign-wide" />
              <SignatureCell label="पद / Designation" value={energisationRequesterDesignation} />
              <SignatureCell label="हस्ताक्षर / Signature" value="" />
            </div>

            {/* ── Certificate of Energisation ── */}
            <div className="iso-section-subheading">
              ऊर्जा प्रदान करने का प्रमाण पत्र / Certificate of Energisation
            </div>

            {/* Cert date/time */}
            <div className="iso-row">
              <span className="iso-label-bold">दिनांक / Date</span>
              <span className="iso-fill iso-fill-sm">{fillValue(formatDate(energisationDetails?.cert_date))}</span>
              <span className="iso-label-bold iso-gap">समय / Time</span>
              <span className="iso-fill iso-fill-sm">{fillValue(formatTime(energisationDetails?.cert_time))}</span>
            </div>

            {/* Certified that Equipment Circuit no. */}
            <div className="iso-row iso-row-wrap">
              <span className="iso-label-bold">
                प्रमाणित किया जाता है कि उपकरण / सर्किट क्र. / Certified that Equipment / Circuit no.
              </span>
              <span className="iso-fill iso-fill-sm">{fillValue(energisationDetails?.certified_equipment_circuit_no)}</span>
              <span className="iso-label-bold iso-gap">का / of</span>
              <span className="iso-fill iso-fill-md">{fillValue(energisationDetails?.ka_of)}</span>
            </div>

            {/* Energized text + checkboxes */}
            <div className="iso-cert-block">
              <span className="iso-label-bold">
                संयंत्र को विद्युत रूप से ऊर्जीकृत किया गया है और सप्लाई पैनल से खतरे का टैग हटा दिया गया है।<br />
                Plant has been electrically energized and the danger tag removed from the supply panel. This is also recorded in the electrical shift logbook.
              </span>
              <div className="iso-option-row iso-option-row-compact">
                <CheckItem checked={isChecked(energisationDetails?.electrically_energized)}>विद्युत ऊर्जीकृत / Electrically Energized</CheckItem>
                <CheckItem checked={isChecked(energisationDetails?.danger_tag_removed)}>खतरे का टैग हटाया / Danger Tag Removed</CheckItem>
                <CheckItem checked={isChecked(energisationDetails?.work_completed_permits_closed)}>कार्य पूर्ण एवं परमिट बंद / Work Completed &amp; Permits Closed</CheckItem>
              </div>
            </div>

            {/* Signature row – Authorized Person */}
            <div className="iso-sign-row iso-sign-row-last">
              <SignatureCell label="अधिकृत व्यक्ति का नाम / Name of Authorized Person" value={energisationDetails?.authorized_person_name} className="iso-sign-wide" />
              <SignatureCell label="पद / Designation" value={energisationDetails?.authorized_person_designation} />
              <SignatureCell label="हस्ताक्षर / Signature" value="" />
            </div>
          </section>

        </div>{/* end iso-page-body */}
      </div>{/* end iso-page-shell */}
    </div>
  );
};

export default IsolationPermitTemplate;